import React from 'react';
import { useLocation } from 'react-router-dom';
import './LoginPage.css';
import './SessionExpiredPage.css';

const NUM_COLS = 90;
const HEX_COLS = Array.from({ length: NUM_COLS }, (_, i) => i);
const HEX_ROWS = Array.from({ length: 20 });

/**
 * Dedicated page shown when a user's session expires due to inactivity.
 * Uses the same branded hex-grid background as the login page.
 */
function SessionExpiredPage() {
  const location = useLocation();
  const reason = location.state?.reason;

  return (
    <div className="login-page">

      {/* Full-screen honeycomb hex field */}
      <div className="login-hex-field" aria-hidden="true">
        {HEX_COLS.map((col) => (
          <div
            key={col}
            className={[
              'login-hex-col-field',
              `login-hex-col-v${col % 5}`,
              col % 2 === 1 ? 'login-hex-col--offset' : '',
            ].join(' ')}
          >
            {HEX_ROWS.map((_, i) => (
              <div key={i} className="login-hex-grid-cell" />
            ))}
          </div>
        ))}
      </div>

      <div className="login-bg-highlight login-bg-highlight--1" aria-hidden="true" />
      <div className="login-bg-highlight login-bg-highlight--2" aria-hidden="true" />
      <div className="login-bg-highlight login-bg-highlight--3" aria-hidden="true" />

      <div className="login-card login-card--visible se-card">

        <div className="se-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="44" height="44" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            <circle cx="12" cy="16" r="1" />
          </svg>
        </div>

        <h1 className="se-title">Session Expired</h1>

        <div className="se-message-box">
          <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          <span>{reason || 'Your session has expired due to inactivity.'}</span>
        </div>

        <p className="se-explanation">
          For your security, sessions end automatically after a period of inactivity.
          Sign in again to continue.
        </p>

        <a href="/login" className="btn btn-primary login-submit login-microsoft-btn se-signin-link">
          Sign in again
        </a>

        <p className="se-footer">
          If you believe this was an error, please contact your administrator.
        </p>

      </div>
    </div>
  );
}

export default SessionExpiredPage;
